import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import fr from './locales/fr.json'
import Tr from './translation'

const getInitialLocale = () => {
  const persistedLocale = localStorage.getItem('user-locale')
  if (persistedLocale && ['en', 'fr'].includes(persistedLocale)) {
    return persistedLocale
  }
  return import.meta.env.VITE_DEFAULT_LOCALE || 'en'
}

export default createI18n({
  locale: getInitialLocale(),
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE || 'en',
  legacy: false,
  globalInjection: true,
  messages: { en, fr }
})